import { useAuthStep } from "@/hooks/useAuthStep";
import { useRef, useEffect } from "react";

import Panels from "@/components/Panels";
import NavHeader from "@/components/NavHeader";
import { CongratulationsImage, Image5, JoinStudentsImage } from "@/components/SidePictures";
import { X } from "lucide-react";
import UnderAge from "../signup/AuthUnderAge";
import Questionairre from "../signup/FinishedQuestionairre";
import ThankYou from "../signup/FinishedThankYou";
import Questionairre3 from "../signup/FinishedQuestionairre3";

import Logins from "./Logins";
import LoginGoogle from "./GoogleLogin";
import OutlookLogin from "./OutlookLogin";
import EmailLogin from "./EmailLogin";
import EmailLoginCode from "./EmailLoginCode";
import AgeVerification from "./AgeVerification";
import { TrySync } from "../signup/TrySync";
import { AuthStepProvider } from "@/hooks/useAuthStep";
import { CommunicationProvider, useCommunication } from "@/lib/CommunicationWrapper";
import { AnimatePresence, motion } from "framer-motion";
import { ClaimTrial } from "../signup/ClaimTrial";
import { TrialClaimed } from "../signup/TrialClaimed";
import { PreviouslyAppliedTheme } from "../signup/PreviouslyAppliedTheme";


const ExitButton = ({ onClick }: { onClick: () => void }) => {

    return (
        <button onClick={onClick} className="hover:scale-108 transition-all duration-200 z-30 shadow-lg absolute top-[10px] right-[10px] bg-white rounded-full p-[10px]">
            <X className="w-[20px] h-[20px]" />
        </button>
    )
}

const LoginImage = () => {

    return (
        <div className="bg-gray-100 w-full h-full bg-cover bg-center flex items-center bg-size-[200%]" style={{ backgroundImage: `url(iconxl.png)` }}>
        </div>
    )
}
const LoginContent = () => {
    const { authStep, setAuthStep } = useAuthStep();
    const isFirstRender = useRef(true);

    const { closeModal } = useCommunication();

    useEffect(() => {
        // After first render, allow animations for subsequent step changes
        if (isFirstRender.current) {
            isFirstRender.current = false;
        }
    }, [authStep]);

    // if none of the handleBack/handkeSkip need any extra proecessing in their functions
    // can make it just a string for the step it needs to go to
    const steps: Record<string, any> = {
        login: {
            left: Logins,
            right: JoinStudentsImage,
            handleBack: null,
            handleSkip: null,
            exit: closeModal,
        },
        googleLogin: {
            left: LoginGoogle,
            right: JoinStudentsImage,
            handleBack: () => setAuthStep("login"),
            handleSkip: null,
            exit: closeModal,
        },
        outlookLogin: {
            left: OutlookLogin,
            right: JoinStudentsImage,
            handleBack: () => setAuthStep("login"),
            handleSkip: null,
            exit: closeModal,
        },
        emailLogin: {
            left: EmailLogin,
            right: JoinStudentsImage,
            handleBack: () => setAuthStep("login"),
            handleSkip: null,
            exit: closeModal,
        },
        emailLoginCode: {
            left: EmailLoginCode,
            right: JoinStudentsImage,
            handleBack: () => setAuthStep("emailLogin"),
            handleSkip: null,
            exit: closeModal,
        },
        ageVerification: {
            left: AgeVerification,
            right: JoinStudentsImage,
            handleBack: () => setAuthStep("login"),
            handleSkip: null,
            exit: closeModal,
        },
        questionairre: {
            left: Questionairre,
            right: CongratulationsImage,
            handleBack: null,
            handleSkip: null,
            exit: null,
        },
        questionairre3: {
            left: Questionairre3,
            right: LoginImage,
            handleBack: null,
            handleSkip: null,
            exit: null,
        },
        underAge: {
            left: UnderAge,
            right: Image5,
            handleBack: () => setAuthStep("login"),
            handleSkip: null,
            exit: null,
        },
        thankYou: {
            left: ThankYou,
            right: LoginImage,
            handleBack: null,
            handleSkip: null,
            exit: closeModal,
        },
        sync: {
            left: TrySync,
            right: CongratulationsImage,
            handleBack: null,
            handleSkip: null,
            exit: null,
        },
        claimTrial: {
            left: ClaimTrial,
            right: CongratulationsImage,
            handleBack: null,
            handleSkip: null,
            exit: null,
        },
        trialClaimed: {
            left: TrialClaimed,
            right: CongratulationsImage,
            handleBack: null,
            handleSkip: null,
            exit: null,
        },
        previouslyAppliedTheme: {
            left: PreviouslyAppliedTheme,
            right: CongratulationsImage,
            handleBack: null,
            handleSkip: null,
            exit: null,
        },

    };

    const LeftComponent = steps[authStep]?.left;
    const RightComponent = steps[authStep]?.right;

    return (
        <Panels>
            <div className="flex-1 flex flex-col h-full w-full">
                {steps[authStep]?.exit && <ExitButton onClick={steps[authStep]?.exit} />}
                <AnimatePresence mode="wait">
                    <motion.div
                        key={authStep}
                        initial={isFirstRender.current ? false : { x: 40, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: -40, opacity: 0 }}
                        transition={{ duration: 0.17, ease: "easeOut" }}
                        className="w-full h-full flex flex-col"

                    >
                        <NavHeader
                            handleBack={steps[authStep]?.handleBack}
                            handleSkip={steps[authStep]?.handleSkip}
                        />
                        {LeftComponent && <LeftComponent />}
                    </motion.div>
                </AnimatePresence>
            </div>
            {RightComponent && <RightComponent />}
        </Panels>
    );


};


const LoginLayout = () => {
    return (
        <CommunicationProvider>
            <AuthStepProvider initial={{ page: "login", step: "login" }}>
                <div className="relative h-full  overflow-scroll h-screen max-w-[1000px] mx-auto">
                    <LoginContent />
                </div>
            </AuthStepProvider>
        </CommunicationProvider>
    );
};

export default LoginLayout;